import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="route-loading">
        <div className="w-8 h-8 border-2 border-[#007F83] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};
